import React from "react";
import { SECURE_SIMPLE_PRACTICE_SIGN_IN } from "../../helpers/signUpFormConstants";

const SpLink = () => (
  <p className="text-forest-900 text-center text-base not-italic font-normal leading-6 w-[410px] md:w-[335px] sm:w-full mx-auto">
    Already have an account?{" "}
    <a
      href={SECURE_SIMPLE_PRACTICE_SIGN_IN}
      rel="noreferrer noopener"
      className="text-forest-900 text-center text-base not-italic font-semibold leading-[160%] underline"
    >
      Log in
    </a>
  </p>
);
export default SpLink;
